import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import {
  CustomResultOfPaginatedListOfGetRefundDeliveryStatuesWithPaginationDto,
  GetEnumValuesDto,
  GetRefundDeliveryStatuesWithPaginationDto,
  PaginatedListOfGetRefundDeliveryStatuesWithPaginationDto,
} from 'src/app/core/api/models';
import { RefundDeliveryStatusesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { DialogService } from '../../../core/services/dialog.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { MatDialogModule } from '@angular/material/dialog';
import { RefundDeliveryStatusFormComponent } from './refund-delivery-status-form/refund-delivery-status-form.component';


@Component({
    selector: 'app-refund-delivery-status',
    templateUrl: './refund-delivery-status.component.html',
    imports: [
        BaseIndexModule,
        MatDialogModule,
        RefundDeliveryStatusFormComponent,
    ]
})
export class RefundDeliveryStatusComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties
  pageName = PageNames.refundDeliveryStatus;

  /* binding service endpoints */
  protected currentService = inject(RefundDeliveryStatusesService);
  paginationApiMethodName: string = this.currentService.refundDeliveryStatusesGetRefundDeliveryStatuesWithPagination.name;
  createGetApiMethodName: string = this.currentService.refundDeliveryStatusesCreateGet.name;

  pageId = 'refundDeliveryStatus';
  modelWithPagination$: Observable<PaginatedListOfGetRefundDeliveryStatuesWithPaginationDto>;
  items$: Observable<Array<GetRefundDeliveryStatuesWithPaginationDto>>;
  RefundDeliveryStatusTypeEnumValues: GetEnumValuesDto[] = [];
  DeliveryStatusEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  constructor(
    public dialogService: DialogService,
    public cd: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAuditBtn = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    // وارد میشود چک میکنیم که کدام جدول باید نمایش داده شود url زمانی که کاربر با
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      if (key == QueryStringTypesEnum.Update_key) {
        let splittedValue = value.toString().split('_');

        this.onUpdateRefundDeliveryStatusType(
          splittedValue[0],
          splittedValue[1],
          splittedValue[2],
          false
        );
      }
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('DeliveryStatus')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.DeliveryStatusEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      { title: 'common.title', name: 'title', hasSearch: true, wrap: true },
      {
        title: `${this.tableVocabs}deliveryStatuses`,
        name: 'deliveryStatuses',
        hasSearch: true,
        type: 'enum',
        enumName: 'DeliveryStatus',
        wrap: true,
      },
    ];
  }

  setDefaultTableSort() {
    this.sortObject.push({ columnName: 'id', sort: 1 });
  }

  //#region Api

  baseDeleteApi(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = id;

    this.currentService
      .refundDeliveryStatusesDelete({ body: { id: id } })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }
  //#endregion

  onUpdateRefundDeliveryStatusType(
    selectedId,
    selectedDeliveryStatuses,
    selectedTitle,
    setFiltersAndUrl = true
  ) {
    if (setFiltersAndUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Update_key +
          '=' +
          selectedId +
          '_' +
          selectedDeliveryStatuses.toString() +
          '_' +
          selectedTitle
      );
    }
    this.formPageConfig.editData = {};
    this.formPageConfig.isEditMode = true;
    this.formPageConfig.editData = {
      title: selectedTitle,
      deliveryStatuses:
        typeof selectedDeliveryStatuses == 'string'
          ? selectedDeliveryStatuses.split(',').map(Number)
          : selectedDeliveryStatuses,
    };
    this.formPageConfig.editId = selectedId;
    this.pageConfig.isVisibleForm = true;
  }
}
